export const wishlistItemKey = (masterId: string, colorCode: string) =>
    `${masterId}|${colorCode}`;

/** Inverse of {@link wishlistItemKey}; `colorCode` may contain `|` but `masterId` must not. */
export const parseWishlistItemKey = (key: string): { masterId: string; colorCode: string } | null => {
    const i = key.indexOf('|');
    if (i <= 0 || i >= key.length - 1) {
        return null;
    }
    return { masterId: key.slice(0, i), colorCode: key.slice(i + 1) };
};
